import React from 'react';
import {FaCar, FaCommentDots, FaExternalLinkAlt, FaNewspaper, FaUser} from "react-icons/fa";
import {getValue} from "../utils.js";
import {useEdgeBuilder} from "../../association-network-context.jsx";
import projectUtils from "../../../../../../utils/project-utils.js";
import BaseNode from "./base-node.jsx";
import {getAssetPath} from "../../../../../../utils/get-asset-path.js";
import CheckHasData from "../check-has-data.jsx";
import {FaCircleInfo, FaFileCircleExclamation} from "react-icons/fa6";
import {Types} from "../enums.js";

const News = ({ data, selected }) => {
    const title = () => {
        return (
            <>
                <p className={"!mb-[2px]"}><b>Notícia</b></p>
            </>
        )
    }

    const icon = (<FaNewspaper size={16} color={"#031b34"}/>);

    const infoBlock = (
        <div className="p-1 text-[7px] border-top border-bottom !border-[#cfcfcf]">
            <div className={"flex items-center mb-1"}>
                <FaExternalLinkAlt/>
                <a href={data.value} target={"_blank"} className={"ml-1 mb-0 overflow-hidden whitespace-nowrap text-ellipsis w-[calc(100%-10px)]"}>
                    {data.value}
                </a>
            </div>
            <div className={"flex"}>
                <div>
                    <FaCircleInfo />
                </div>
                <p className="mb-0 ml-1 text-[6px] overflow-hidden [display:-webkit-box] [-webkit-line-clamp:4] [-webkit-box-orient:vertical]">
                    <CheckHasData value={data.additionalValue} />
                </p>
            </div>
        </div>
    );

    return (
        <BaseNode
            icon={icon}
            title={title()}
            image={null}
            infoBlock={infoBlock}
            onSearchAll={() => {}}
            showAddConnectionButton={true}
            selected={selected}
            bgHeader={"bg-[#ff8b40]"}
            bgBody={"bg-[#fff9d7]"}
            type={Types.NEWS}
        />
    );
};

export default News;